import { render, staticRenderFns } from "./WorkOrderField.vue?vue&type=template&id=64c47fcc&scoped=true"
import script from "./WorkOrderField.vue?vue&type=script&lang=js"
export * from "./WorkOrderField.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderField.vue?vue&type=style&index=0&id=64c47fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c47fcc",
  null
  
)

export default component.exports